import React from 'react';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';

const Layout = React.lazy(() => import('@/components/ui/layout/layout'));
const Home = React.lazy(() => import('@/pages/home'));

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PT routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
        {/* EN routes */}
        <Route path="/en" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="*" element={<Navigate to="/en" replace />} />
        </Route>
        {/* Fallback to PT / */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
